module.exports = __webpack_public_path__ + "media/entities/2205-eb42125c.png";